import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  const points = [
    "Expertise locale avec vision internationale",
    "Solutions sur-mesure basées sur vos KPIs",
    "Accompagnement de A à Z (Stratégie à Exécution)",
    "Transparence totale et reporting régulier"
  ];
  return (
    <section id="about" className="py-20 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="absolute -top-8 -left-8 w-40 h-40 bg-brand-lime/10 rounded-full blur-3xl pointer-events-none" />
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
              <img
                src="https://res.cloudinary.com/dzi7hex2h/image/upload/v1779733913/bureau_hybltp.jpg"
                alt="Notre Équipe au travail"
                className="w-full h-full object-cover aspect-[4/3] hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-purple rounded-2xl -z-10 opacity-10" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-brand-lime font-bold tracking-widest uppercase text-sm mb-4">À propos</h2>
            <h3 className="text-4xl md:text-5xl font-display font-bold text-brand-purple mb-8 leading-tight">
              Plus qu'une agence, votre <span className="text-brand-lime">partenaire stratégique</span>
            </h3>
            <p className="text-lg text-brand-purple/70 mb-10 leading-relaxed text-pretty">
              Basée au cœur du Sénégal, Teranga Digital accompagne les entreprises locales et internationales dans leur transformation numérique. Nous croyons que chaque marque a une histoire unique à raconter, et nous sommes là pour lui donner une voix puissante dans le monde digital.
            </p>
            <ul className="space-y-5">
              {points.map((item, i) => (
                <li key={i} className="flex items-center gap-4 text-brand-purple/80 font-medium">
                  <div className="w-6 h-6 rounded-full bg-brand-lime/20 flex items-center justify-center flex-shrink-0">
                    <div className="w-2 h-2 rounded-full bg-brand-purple" />
                  </div>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
